import React from 'react';
import { UiKit } from '@datavant/uikit';
import { VStack } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const HJPremiseModal = (props: { onClose: () => void; isOpen: boolean }) => {
    const onClick = () => {
        const url =
            'https://bookings.cloud.microsoft/book/DatavantSiteConnectROIAgentInstallation@datavant.com/?ismsaljsauthenabled=true';
        window.open(url, '_blank');
    };

    const ModalBody = (
        <VStack width={'100%'} alignItems={'left'}>
            <UiKit.Text.BodyRegular>
                To move forward with Autofulfill setup, please schedule your installation appointment
            </UiKit.Text.BodyRegular>
            <UiKit.Chakra.UnorderedList>
                <UiKit.Chakra.ListItem>
                    <UiKit.Text.BodyRegular>
                        Requirements are listed in the scheduling link on the left panel
                    </UiKit.Text.BodyRegular>
                </UiKit.Chakra.ListItem>
                <UiKit.Chakra.ListItem>
                    <UiKit.Text.BodyRegular>
                        Prefer a pre-installation call? Email us at requestmanager@datavant.com
                    </UiKit.Text.BodyRegular>
                </UiKit.Chakra.ListItem>
            </UiKit.Chakra.UnorderedList>
        </VStack>
    );

    const ModalFooter = (
        <UiKit.Chakra.VStack>
            <UiKit.Chakra.HStack w={'full'} justifyContent={'flex-end'} spacing={UiKit.consistency.buffer}>
                <UiKit.Button.Cancel text={'Not Now'} onClick={props.onClose} />
                <UiKit.Button.Primary
                    text="Schedule Installation"
                    onClick={onClick}
                    rightIcon={<FontAwesomeIcon icon={UiKit.Icons.FontAwesome.solid.faArrowRight} />}
                />
            </UiKit.Chakra.HStack>
        </UiKit.Chakra.VStack>
    );

    return (
        <UiKit.Modal
            title={'Schedule Installation'}
            bodyFragment={ModalBody}
            footerFragment={ModalFooter}
            onClose={props.onClose}
            isOpen={props.isOpen}
            size={'2xl'}
            fullScreen={false}
        />
    );
};
